<script>
export default {
  name: 'Slider',
  props: ['autoSlidingDisabled'],
  render(createElement) {
    return createElement('div', { class: 'slider' }, this.$slots.default);
  },
  data() {
    return {
      items: [],
      isDown: false,
      startX: 0,
      startY: 0,
      pos: 0,
      translateAmount: 0,
      itemsContainerWidth: 0,
      move: 0,
      clientWidth: 0,
      elementLeftX: 0,
      intervalCallback: {},
      animationEnd: 0,
    };
  },
  mounted() {
    this.getAllItems();
    this.getItemsContainerWidth();
    if (!this.autoSlidingDisabled) {
      this.initializeSliding();
      while (this.$el.clientWidth >= this.itemsContainerWidth - Math.max(...this.items.map(item => item.width))) {
        this.items.forEach(item => this.$el.appendChild(item.element.cloneNode(true)));
        this.getAllItems();
        this.getItemsContainerWidth();
      }
    }

    this.$el.addEventListener('touchend', this.handleSlideEnd, { passive: true });
    this.$el.addEventListener('touchcancel', this.handleSlideEnd, { passive: true });
    this.$el.addEventListener('touchmove', this.handleSlideTouchMove, { passive: true });
    this.$el.addEventListener('touchstart', this.handleSlideTouchStart, { passive: true });
    this.$el.addEventListener('mouseup', this.handleSlideEnd);
    this.$el.addEventListener('mousedown', this.handleSlideStart);
    this.$el.addEventListener('mouseleave', this.handleSlideEnd);
    this.$el.addEventListener('mousemove', this.handleSlideMouseMove);
  },
  methods: {
    getItemsContainerWidth: function() {
      this.itemsContainerWidth = this.items.reduce(
        (widthSum, item) => (widthSum += this.getElementWidthWithMargins(item.element)),
        0,
      );
    },
    getAllItems: function() {
      const items = [...this.$el.getElementsByClassName('slider-item')];
      items.slice(this.items.length).forEach(item => {
        this.items.push({
          element: item,
          width: this.getElementWidthWithMargins(item),
          currentTransition: 0,
        });
      });
    },
    getElementWidthWithMargins: function(element) {
      return (
        element.clientWidth +
        parseInt(window.getComputedStyle(element).marginRight, 10) +
        parseInt(window.getComputedStyle(element).marginLeft, 10)
      );
    },
    handleSlideStart: function(event) {
      this.isDown = true;
      this.$el.classList.remove('sliding');
      this.startX = event.pageX;
    },
    handleSlideMove: function(event) {
      if (!this.isDown) return;
      const x = event.pageX + this.pos;
      const canSlideInAutoSlide = !this.autoSlidingDisabled && -(x - this.startX) > 0;
      const canSlide =
        0 < -(x - this.startX) && this.itemsContainerWidth - this.$el.clientWidth / 1.2 > -(x - this.startX);

      if (canSlideInAutoSlide || canSlide) {
        this.move = x - this.startX;
        this.$el.style.transform = `translate3d(${this.move}px, 0, 0)`;
      }

      const runEnd = () => {
        if (x - this.startX < 200 && this.itemsContainerWidth - this.$el.clientWidth / 1.6 > -(x - this.startX)) {
          this.animationEnd = x - this.startX;
          this.$el.style.transition = 'transform 0.2s ease-in';
          this.$el.style.transform = `translate3d(${this.animationEnd}px, 0, 0)`;
        }
      };

      if (!canSlide && this.autoSlidingDisabled) {
        runEnd();
      }
      if (!this.autoSlidingDisabled) this.translateIfNeccessary();
    },
    handleSlideEnd: function() {
      this.isDown = false;
      setTimeout(() => {
        this.$el.style.transition = ``;
        this.animationEnd = 0;
      }, 200);
      this.pos = this.move;
      this.$el.style.transform = `translate3d(${this.move}px, 0, 0)`;
      this.$el.classList.add('sliding');
    },
    handleSlideMouseMove: function(e) {
      this.handleSlideMove(e);
    },
    handleSlideTouchMove: function(e) {
      const touch = e.touches[0];
      const y = touch.pageY - window.scrollY;
      const walk = -(y - this.startY) * 0.03;
      window.scrollBy(0, walk);
      this.handleSlideMove(touch);
    },
    handleSlideTouchStart: function(e) {
      const touch = e.touches[0];
      this.startY = touch.pageY - window.scrollY;
      this.handleSlideStart(touch);
    },
    translateItem: function(index, translate) {
      const item = this.items[index].element;
      item.style.transform = `translate3d(${translate}px, 0, 0)`;
    },
    translateIfNeccessary: function() {
      const simulatedScroll = -this.move + this.elementLeftX;

      this.items.forEach((item, index) => {
        const forwardItemPosition = (item.currentTransition + 1) * this.itemsContainerWidth;
        const backwardItemPosition = item.currentTransition * this.itemsContainerWidth;
        if (simulatedScroll + this.itemsContainerWidth > forwardItemPosition + item.width * (index + 1)) {
          this.translateItem(index, forwardItemPosition);
          item.currentTransition++;
        } else if (simulatedScroll + this.itemsContainerWidth < forwardItemPosition + item.width * (index + 1)) {
          this.translateItem(index, backwardItemPosition);
          item.currentTransition--;
        }
      });
    },
    slidingAnimation: function() {
      if (!this.$el.classList.contains('sliding')) return;
      else {
        this.pos--;
        this.move = this.pos;
        this.$el.style.transform = `translate3d(${this.pos}px, 0, 0)`;
        this.translateIfNeccessary();
      }
    },
    initializeSliding: function() {
      this.$el.classList.add('sliding');
      this.elementLeftX = this.$el.getClientRects()[0].left;
      setTimeout(() => {
        setInterval(this.slidingAnimation, 10);
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize');
    },
  },
};
</script>
